import { mxgraphInstance } from './mxgraphFactory';

/**
 * Util
 */
export const mxAbstractCanvas2D = mxgraphInstance.mxAbstractCanvas2D;
export const mxAnimation = mxgraphInstance.mxAnimation;
export const mxAutoSaveManager = mxgraphInstance.mxAutoSaveManager;
export const mxClipboard = mxgraphInstance.mxClipboard;
export const mxConstants = mxgraphInstance.mxConstants;
export const mxDictionary = mxgraphInstance.mxDictionary;
export const mxDivResizer = mxgraphInstance.mxDivResizer;
export const mxDragSource = mxgraphInstance.mxDragSource;
export const mxEffects = mxgraphInstance.mxEffects;
export const mxEvent = mxgraphInstance.mxEvent;
export const mxEventObject = mxgraphInstance.mxEventObject;
export const mxEventSource = mxgraphInstance.mxEventSource;
export const mxForm = mxgraphInstance.mxForm;
export const mxGuide = mxgraphInstance.mxGuide;
export const mxImage = mxgraphInstance.mxImage;
export const mxImageBundle = mxgraphInstance.mxImageBundle;
export const mxImageExport = mxgraphInstance.mxImageExport;
export const mxLog = mxgraphInstance.mxLog;
export const mxMorphing = mxgraphInstance.mxMorphing;
export const mxMouseEvent = mxgraphInstance.mxMouseEvent;
export const mxObjectIdentity = mxgraphInstance.mxObjectIdentity;
export const mxPanningManager = mxgraphInstance.mxPanningManager;
export const mxPoint = mxgraphInstance.mxPoint;
export const mxPopupMenu = mxgraphInstance.mxPopupMenu;
export const mxRectangle = mxgraphInstance.mxRectangle;
export const mxResources = mxgraphInstance.mxResources;
export const mxSvgCanvas2D = mxgraphInstance.mxSvgCanvas2D;
export const mxToolbar = mxgraphInstance.mxToolbar;
export const mxUndoableEdit = mxgraphInstance.mxUndoableEdit;
export const mxUndoManager = mxgraphInstance.mxUndoManager;
export const mxUrlConverter = mxgraphInstance.mxUrlConverter;
export const mxUtils = mxgraphInstance.mxUtils;
export const mxVmlCanvas2D = mxgraphInstance.mxVmlCanvas2D;
export const mxWindow = mxgraphInstance.mxWindow;
export const mxXmlCanvas2D = mxgraphInstance.mxXmlCanvas2D;
export const mxXmlRequest = mxgraphInstance.mxXmlRequest;